module.exports = __webpack_public_path__ + "img/centra-logo.5c93d482.svg";